import store from "@/store";
import _ from "@/boot/lodash";
import { BrandConfigKeys } from "@/data/constants";

export default [
  {
    children: [
      {
        label: "_.profile",
        to: {
          name: "clientAccountProfile"
        }
      },
      {
        label: "_.security",
        to: {
          name: "clientAccountSecurity"
        }
      },
      {
        label: "_.email_history",
        to: {
          name: "clientAccountEmailHistory"
        }
      },
      {
        label: "_.affiliate_program",
        if: () => {
          const config = store.getters["brand/config"];
          return (
            _.get(
              config,
              BrandConfigKeys.UPMIND_AFFILIATES_CUSTOMER_CONTROLS_ENABLED
            ) && _.get(config, BrandConfigKeys.UPMIND_AFFILIATES_ENABLED)
          );
        },
        to: {
          name: "clientAffiliate"
        },
        children: [
          {
            label: "_.overview",
            to: {
              name: "clientAffiliateOverview"
            }
          },
          {
            label: "_.commissions",
            to: {
              name: "clientAffiliateCommissions"
            }
          },
          {
            label: "_.payouts",
            to: {
              name: "clientAffiliatePayouts"
            }
          }
          // {
          //   label: "_.settings",
          //   to: {
          //     name: "clientAffiliateSettings"
          //   }
          // }
        ]
      }
    ]
  }
];
